import { toast } from "react-toastify"

export const handleTitleEdit = (id, currentTitle, setEditingId, setEditingTitle) => {
  setEditingId(id)
  setEditingTitle(currentTitle || "")
}

export const handleTitleSave = async (
  id,
  items,
  updateFunction,
  reloadFunction,
  editingTitle,
  setEditingId,
  setEditingTitle,
  itemType,
  talentId,
  additionalData
) => {
  if (!editingTitle.trim()) {
    toast.error(`O título do ${itemType} não pode ficar vazio!`)
    return
  }

  try {
    const currentItem = items.find((item) => item.id === id)
    if (!currentItem) return

    const updatedData = {
      ...additionalData,
      title: editingTitle.trim(), // Mapeia para title_photo ou title_video no updateFunction
    }

    await updateFunction(talentId, id, updatedData)
    await reloadFunction()
    setEditingId(null)
    setEditingTitle("")
    toast.success(`Título do ${itemType} atualizado com sucesso!`)
  } catch (error) {
    toast.error(`Erro ao salvar o título do ${itemType}. Tente novamente.`)
  }
}

export const handleTitleCancel = (setEditingId, setEditingTitle) => {
  setEditingId(null)
  setEditingTitle("")
}